import Styled from 'styled-components';
import { respondTo } from '@/respondTo'; 
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

export const ImgCard = Styled.img<{active?:boolean, size?:string }>`
    display: ${({size })=> size === 'small' ? '' : 'none'};
    width: 100%;
    height: auto;
    position: relative;
    margin: 0 auto;


    ${respondTo.tablet_portrait`
        height: 450px;
        width: auto;
        `}

    ${respondTo.tablet_landscape_s`
    max-width: 100%;
    margin:unset;
    display: ${({size} : any )=> size === 'large' ? 'flex' : 'none'};
    height: auto;     
    min-height: 628px;
    `} 
`

export const CustomTabs= Styled(Tabs)`	
    width:100%;
    padding:0 1rem 0 0.625rem;
    display:flex;
    justify-content:center;
`
export const CustomTab = Styled(Tab)`
    padding: 0.8125rem 0.5rem ;
    font-weight: 500;
    letter-spacing: 0.46px;
    line-height: 22px;
    text-transform: none;
    font-size: 0.8125rem ;
    ${respondTo.desktop`
        font-size: 0.875rem ;
        `}
    ${respondTo.desktop_xl`
        font-size: 1.125rem ;
        `}
  
`
    



export const ItemsBox = Styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding: 1.25rem 0 0;
    color: var(--on-primary-container-light);

    ${respondTo.desktop`
        padding:0;
        `}
  
    `;
export const ItemsContainer = Styled.div`
  ${respondTo.desktop`
   min-height: 8.4rem;
   `}


   `

export const ItemTitleBox = Styled.div` 
    display: flex;
    flex-direction: row;
    width: 100%;
    height:100%;
   
    
`	

export const BulletPoint= Styled.img`
    width: 1.5rem;
    height: auto;
    margin-right: 0.5rem;

    ${respondTo.desktop`
        width: 1.5rem;
        height: auto;
        object-fit: contain;
    `}

    ${respondTo.desktop_xl`
        width: 2rem;
        height: auto;
        object-fit: contain;
    `}
    `

export const ItemDescription = Styled.p`
    display: block;
    padding: 0.625rem 0 0 2rem; 

    ${respondTo.desktop`
        padding: 0.625rem 0 0 1rem;
        margin: 0 0 0.5rem;
        
    `}
    

    ${respondTo.desktop_xl`
        padding: 0.625rem 0 0 2.6rem;
        margin: 0 0 0.625rem;
    `}
`

export const ItemContainer = Styled.div`

`



export const BtnContainer = Styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-end;
    margin-top: 1.25rem;
    padding: 0 1.25rem 0; 
    
    ${respondTo.tablet_landscape_s`
         padding:0;
         width: 100%;
         justify-content: flex-end;
         position: absolute;
         bottom: -2rem;
         right: 0rem;
        `}
    

    ${respondTo.desktop`

        bottom: 0rem;
   
    `}
   
   
    


` 